export enum PddDeviceFingerPrintErrorType {
    /** 从接口获取PageCode出现异常 */
    GET_PAGE_CODE_ERROR = "GET_PAGE_CODE_ERROR",

    /** 从接口获取到PageCode，但为空 */
    PAGE_CODE_NULL_ERROR = "PAGE_CODE_NULL_ERROR",

    /** 无PDD_OPEN_init方法 */
    NO_PDD_OPEN_INIT_ERROR_FUNC = "NO_PDD_OPEN_INIT_ERROR",

    /* PDD_OPEN_init执行报错 */
    PDD_OPEN_INIT_EXEC_ERROR = "PDD_OPEN_INIT_EXEC_ERROR",

    /** 无PDD_OPEN_getPati方法 */
    NO_PDD_OPEN_GET_PATI_FUNC = "NO_PDD_OPEN_GET_PATI_FUNC",

    /** 获取PDD_PATI超时 */
    GET_PDD_PATI_TIMEOUT = "GET_PDD_PATI_TIMEOUT",

    /** 从接口获取到Pati，但为空 */
    PATI_NULL_ERROR = "PATI_NULL_ERROR",

    /** 从接口获取Pati出现异常 */
    GET_PDD_PATI_ERROR = "GET_PDD_PATI_ERROR",
}

const PddDeviceFingerPrintErrorMap = {
    [PddDeviceFingerPrintErrorType.GET_PAGE_CODE_ERROR]: "从接口获取PageCode出现异常",
    [PddDeviceFingerPrintErrorType.PAGE_CODE_NULL_ERROR]: "从接口获取到PageCode，但为空",
    [PddDeviceFingerPrintErrorType.NO_PDD_OPEN_INIT_ERROR_FUNC]: "无PDD_OPEN_init方法",
    [PddDeviceFingerPrintErrorType.PDD_OPEN_INIT_EXEC_ERROR]: "PDD_OPEN_init执行报错",
    [PddDeviceFingerPrintErrorType.NO_PDD_OPEN_GET_PATI_FUNC]: "无PDD_OPEN_getPati方法",
    [PddDeviceFingerPrintErrorType.GET_PDD_PATI_TIMEOUT]: "获取PDD_PATI超时",
    [PddDeviceFingerPrintErrorType.PATI_NULL_ERROR]: "从接口获取到Pati，但为空",
    [PddDeviceFingerPrintErrorType.GET_PDD_PATI_ERROR]: "从接口获取Pati出现异常",
};

class PddDeviceFingerPrintError extends Error {
    type: PddDeviceFingerPrintErrorType;

    constructor(type: PddDeviceFingerPrintErrorType, message: string = "") {
        super();

        this.type = type;

        this.message = `【拼多多指纹锁异常】【${PddDeviceFingerPrintErrorMap[type]}】:${message}`;
    }
}

export default PddDeviceFingerPrintError;
